module.exports = __webpack_public_path__ + "img/bg-matching1.b674279e.gif";